import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "axios";

axios.defaults.baseURL = "https://wow.pesa.solutions/api/"; //prod
//axios.defaults.baseURL = "http://localhost:12340/api/"; //dev
// Create an Axios instance for read operations

axios.defaults.withCredentials = true;

const el = document.getElementById("root");

const root = ReactDOM.createRoot(el);

root.render(<App />);
